module.exports = __webpack_public_path__ + "static/media/logo-horizontal.a7193856.svg";